import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { WidgetsModule } from '../../widgets/widgets.module';
import { EffectsModule } from '@ngrx/effects';
import { EmailDigestEffect } from '../../redux/effects/email-digest.effects';
import { EmailDigestListComponent } from '../../components/email-digest/email-digest-list.component';
import { EmailDigestActionsComponent } from '../../components/email-digest/email-digest-actions.component';
import { EmailDigestEditorComponent } from './email-digest-editor.component';
import { EmailDigestEditorSubChromeComponent } from './email-digest-editor-sub-chrome.component';
import { EmailDigestFilterComponent } from '../../components/email-digest/email-digest-filter/email-digest-filter.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { EmailDigestFilterService } from '../../tamalelibs/services/email-digest-filter.service';
import { EmailDigestSchedulerInfoComponent } from '../../components/email-digest/email-digest-scheduler-info.component';
import { EmailDigestServiceCommon } from '../../components/email-digest/email-digest-common.service';

@NgModule({
    imports: [
        CommonModule,
        AgGridModule,
        InputsModule,
        DateInputsModule,
        DropDownsModule,
        ButtonsModule,
        PopupModule,
        TooltipModule,
        WidgetsModule,
        EffectsModule.forFeature([
            EmailDigestEffect,
        ]),
    ],
    declarations: [
        EmailDigestListComponent,
        EmailDigestActionsComponent,
        EmailDigestEditorComponent,
        EmailDigestEditorSubChromeComponent,
        EmailDigestFilterComponent,
        EmailDigestSchedulerInfoComponent,
    ],
    providers: [
        EmailDigestFilterService,
        EmailDigestServiceCommon
    ],
    exports: [
        EmailDigestListComponent,
        EmailDigestEditorComponent,
    ]
})
export class EmailDigestModule { }
